const remove = () => {
  const body = document.querySelector('body');

  if (body) {
    body.style.setProperty('--footer-extra-bottom-padding', `0px`);
  }
};

const add = (height: number | undefined) => {
  const body = document.querySelector('body');
  if (!body) {
    return;
  }

  body.style.setProperty('--footer-extra-bottom-padding', `${height || 0}px`);
};

export const footerPaddings = {
  remove,
  add,
};
